import script from "./Chip.vue?vue&type=script&setup=true&lang=js"
export * from "./Chip.vue?vue&type=script&setup=true&lang=js"

import "./Chip.vue?vue&type=style&index=0&id=e84dd3f0&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e84dd3f0"]])

export default __exports__